import antdSpanish from "antd/lib/locale-provider/es_ES"
import messages from "../locales/es_ES.json"

const SpanishLanguage = {
  messages: {
    ...messages,
  },
  antd: antdSpanish,
  locale: "es-ES",
}

export default SpanishLanguage
